import * as S from './styles'
import { ReactNode } from 'react'

export type ButtonProps = {
  id: string
  children: ReactNode | string
  primary?: boolean
  outline?: boolean
  disabled?: boolean
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void
  cleared?: boolean
  noBackground?: boolean
  name?: string
  type?: 'button' | 'submit' | 'reset'
  width?: number
}

const Button = ({
  id,
  name,
  children,
  onClick,
  width,
  primary = true,
  outline = false,
  disabled = false,
  cleared = false,
  noBackground = false,
  type = 'submit',
  ...restAttributes
}: ButtonProps) => {
  return (
    <S.BaseButton
      id={id}
      type={type}
      disabled={disabled}
      isPrimary={primary}
      isOutline={outline}
      isCleared={cleared}
      isDisabled={disabled}
      isNoBackground={noBackground}
      onClick={onClick}
      name={name}
      width={width}
      {...restAttributes}
    >
      {children}
    </S.BaseButton>
  )
}

export default Button
